var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout d-flex flex-column"},[_c('global-nav'),_c('router-view',{staticClass:"flex-grow-1"}),_c('global-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }